import { useSelector } from 'react-redux';
import { selectCurrentOrder } from 'Redux/Order/slice';
import { ReactComponent as Phone } from 'Assets/links/grey-phone.svg';
import { ReactComponent as Email } from 'Assets/links/email.svg';
import { clearPhoneNumber } from 'Shared/Utils';
import styles from './Broker.module.scss';

export const Broker: React.FC = () => {
  const currentOrder = useSelector(selectCurrentOrder);

  return (
    <div className={styles.broker}>
      <div className={styles.broker__contacts}>
        <div className={styles.broker__contacts__name}>Broker</div>

        <div className={styles.broker__contacts__links}>
          {currentOrder?.broker_phone && (
            <a
              className={styles.broker__contacts__link}
              href={`tel:${clearPhoneNumber(currentOrder?.broker_phone)}`}
              target="_blank"
              rel="noreferrer"
            >
              <Phone
                className={styles.broker__contacts__icon}
                title="Make a call to the broker"
              />
            </a>
          )}

          <a
            className={styles.broker__contacts__link}
            href={`mailto:${currentOrder?.email}`}
            target="_blank"
            rel="noreferrer"
          >
            <Email
              className={styles.broker__contacts__icon}
              title="Send an email to the broker"
            />
          </a>
        </div>
      </div>

      <div className={styles.broker__name}>{currentOrder?.broker}</div>
    </div>
  );
};
